module.exports = __webpack_public_path__ + "img/Group 1.3bfd875b.png";